<template lang="pug">
v-sheet(width="100%")
  v-img.elevation-1.rounded-sm.staff-card-img.primary(
    :src="img + '?resize=1&w=300'",
    :aspect-ratio="1",
    :alt="title"
  )
    v-card.staff-card-button.justify-center.align-center(
      @click="dialog = true",
      height="100%",
      width="100%",
      color="#00000055",
      target="_blank"
    )
      .d-flex.flex-column.justify-center.align-center
        v-btn(color="secondary", fab)
          v-icon fas fa-eye
        v-chip.mt-4 Ver mais
  .text-body-2.primary--text.text-center.mt-2.font-weight-bold {{ title }}
  v-dialog(v-model="dialog", max-width="800px")
    v-card
      grid-container(
        cols="auto",
        cols-sm="300px auto",
        cols-lg="300px auto",
        gap="0px"
      )
        v-img.elevation-1.rounded-sm.staff-card-img(
          :src="img + '?resize=1&w=300'",
          :aspect-ratio="1",
          :alt="title"
        )
        .py-2.px-4
          .text-h6.primary--text.mt-2.font-weight-bold {{ title }}
          .font-weight-bold.text-uppercase.mb-2 {{ office }}
          .text-body-2.font-weight-bold {{ textWithoutHTML }}
          .text-body-2.mt-2
            div(v-if="email")
              v-icon.mt-n1(left, small) fas fa-envelope
              span {{ email }}
            div(v-if="facebook")
              v-icon.mt-n1(left, small) fab fa-facebook
              span {{ facebook }}
            div(v-if="instagram")
              v-icon.mt-n1(left, small) fab fa-instagram
              span {{ instagram }}
            div(v-if="google")
              v-icon.mt-n1(left, small) fab fa-google
              span {{ google }}
            div(v-if="twitter")
              v-icon.mt-n1(left, small) fab fa-twitter
              span {{ twitter }}
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    img: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    office: String,
    email: String,
    facebook: String,
    instagram: String,
    google: String,
    twitter: String,
  },
  data: () => ({
    dialog: false,
  }),
  computed: {
    textWithoutHTML() {
      let d = document.createElement("div");
      d.innerHTML = this.text;
      return d.textContent;
    },
  },
};
</script>



<style>
.staff-card-button {
  display: none;
  height: 100%;
  width: 100%;
}
.staff-card-img:hover .staff-card-button {
  display: flex;
}
.staff-card-title {
  line-height: 20px !important;
}
</style>
